import React, { useState } from 'react'

import './styles.scss'
import InputField from 'components/TranslationsView/InputField'
import { SelectWithLabel } from 'components/Form'
import { InputControls } from 'components/common'
import { locales } from 'components/TranslationsView/utils'
import { lang } from 'utils/helpers'

const FiltersSection = props => {
  const { labelsOptions, onChange, selectedLocale } = props

  const localesOptions = locales.map(value => ({ value, label: lang(`locale_${value}`) }))

  const platformOptions = [
    { value: 'all', label: lang('dashboard_all') },
    { value: 'dashboard', label: 'Dashboard' },
    { value: 'email', label: 'Email' },
    { value: 'app', label: 'App' }
  ]
  const [text, setText] = useState('')
  const [locale, setLocale] = useState(localesOptions.find(e => e.value === selectedLocale) || localesOptions[0])
  const [matchExact, setMatchExact] = useState(false)
  const [onlyRemoved, setOnlyRemoved] = useState(false)
  const [onlyModified, setOnlyModified] = useState(false)
  const [withoutLabels, setWithoutLabels] = useState(false)
  const [onlyTags, setOnlyTags] = useState(false)
  const [platform, setPlatform] = useState(platformOptions[0] || null)
  const [labels, setLabels] = useState(null)

  const handleOnChange = ({ field, value }) => {
    const filters = { page: 0, pageSize: 30 }

    if (text) filters.text = text
    filters.locale = locale.value
    filters.matchExact = !!matchExact
    filters.onlyRemoved = !!onlyRemoved
    filters.onlyModified = !!onlyModified
    filters.withoutLabels = !!withoutLabels
    filters.onlyTags = !!onlyTags
    filters.platform = platform.value
    if (labels?.length) filters.labels = labels.map(({ value }) => value)

    switch (field) {
      case 'text':
        setText(value)
        if (value) {
          filters.text = value
        } else {
          delete filters.text
        }
        break
      case 'locale':
        setLocale(value)
        filters.locale = value.value
        break
      case 'matchExact':
        setMatchExact(value)
        filters.matchExact = value
        break
      case 'onlyRemoved':
        setOnlyRemoved(value)
        filters.onlyRemoved = value
        break
      case 'onlyModified':
        setOnlyModified(value)
        filters.onlyModified = value
        break
      case 'withoutLabels':
        setWithoutLabels(value)
        filters.withoutLabels = value
        break
      case 'onlyTags':
        setOnlyTags(value)
        filters.onlyTags = value
        break
      case 'platform':
        setPlatform(value)
        filters.platform = value.value
        break
      case 'labels':
        setLabels(value)
        if (value?.length) {
          filters.labels = value.map(({ value }) => value)
        } else {
          delete filters.labels
        }
        break
      default:
        break
    }

    onChange(filters)
  }

  return (
    <div className='translations-translations-section-filters'>
      <InputField
        inputValue={text}
        selectorValue={locale}
        selectorOptions={localesOptions}
        onChangeInput={value => handleOnChange({ field: 'text', value })}
        onChangeSelector={value => handleOnChange({ field: 'locale', value })}
      />
      <InputControls
        className='translations-translations-section-filters__switch'
        labelLeft={lang('dashboard_exact-search')}
        value={matchExact}
        onChange={value => handleOnChange({ field: 'matchExact', value })}
      />
      <InputControls
        className='translations-translations-section-filters__switch'
        labelLeft={lang('dashboard_without-labels')}
        value={withoutLabels}
        onChange={value => handleOnChange({ field: 'withoutLabels', value })}
      />
      <SelectWithLabel
        classNameWrapper='translations-translations-section-filters__selector'
        label={lang('dashboard_platform')}
        options={platformOptions}
        value={platform}
        onChange={value => handleOnChange({ field: 'platform', value })}
      />
      <SelectWithLabel
        multi
        isClearable
        classNameWrapper='translations-translations-section-filters__selector'
        label={lang('dashboard_labels')}
        placeholder={lang('dashboard_select')}
        options={labelsOptions}
        value={labels}
        onChange={value => handleOnChange({ field: 'labels', value })}
      />
      <InputControls
        className='translations-translations-section-filters__switch'
        labelLeft={lang('dashboard_show-modified')}
        value={onlyModified}
        onChange={value => handleOnChange({ field: 'onlyModified', value })}
      />
      <InputControls
        className='translations-translations-section-filters__switch'
        labelLeft={lang('dashboard_show-deleted')}
        value={onlyRemoved}
        onChange={value => handleOnChange({ field: 'onlyRemoved', value })}
      />
      <InputControls
        className='translations-translations-section-filters__switch'
        labelLeft={lang('translation_display_only_tags')}
        value={onlyTags}
        onChange={value => handleOnChange({ field: 'onlyTags', value })}
      />
    </div>
  )
}

export default FiltersSection
